(function () {
  'use strict';

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    });
  }

  /* Ouvre le formulaire COD (EasySell) s'il est présent, sinon checkout classique. */
  function openCheckout() {
    var es = document.querySelector('#es-sticky, .es-sticky-btn, [id^="es-sticky"]');
    if (es) { es.click(); return; }
    window.location.href = '/checkout';
  }

  function order(btn) {
    var variant = btn.getAttribute('data-variant');
    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
    if (!variant) { window.location.href = '/cart'; return; }
    var label = btn.innerHTML;
    btn.setAttribute('disabled', 'disabled');
    btn.innerHTML = 'Un instant…';
    post('/cart/clear.js')
      .then(function () { return post('/cart/add.js', { items: [{ id: parseInt(variant, 10), quantity: qty }] }); })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { setTimeout(openCheckout, 250); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        setTimeout(function () { btn.removeAttribute('disabled'); btn.innerHTML = label; }, 2500);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sk-order]');
    if (!btn) return;
    e.preventDefault();
    order(btn);
  });

  /* Sélection visuelle d'un pack : met à jour la barre collante. */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-sk-pack]');
    if (!card) return;
    document.querySelectorAll('[data-sk-pack]').forEach(function (c) { c.classList.remove('sk-pack--best'); });
    card.classList.add('sk-pack--best');
    var bar = document.querySelector('[data-sk-sticky-price]');
    var btn = document.querySelector('[data-sk-sticky-btn]');
    if (bar && card.getAttribute('data-price')) bar.textContent = card.getAttribute('data-price');
    if (btn && card.getAttribute('data-qty')) btn.setAttribute('data-qty', card.getAttribute('data-qty'));
  });

  /* Barre d'achat collante mobile : apparaît une fois le hero dépassé. */
  var sticky = document.querySelector('.sk-sticky');
  if (sticky) {
    var trigger = document.querySelector('.sk-hero') || document.body;
    window.addEventListener('scroll', function () {
      var past = window.scrollY > (trigger.offsetHeight || 400) * 0.75;
      sticky.classList.toggle('sk-sticky--on', past);
    }, { passive: true });
  }

  /* Défilement doux vers les packs. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var t = document.querySelector(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
